import React, { useEffect, useState } from 'react'
import { useFormik } from 'formik'
import { useNavigate, useParams } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import { AppDispatch } from '../../../../../redux/store'
import {
  createDealerPriceListApi,
  getDealerPriceListByIdApi,
  updateDealerPriceListApi,
} from '../../../../../redux/slices/DealerPriceListSlice'
import { toast } from 'react-toastify'
import * as Yup from 'yup'

const DealerPriceListForm = () => {
  const { id } = useParams()
  const dispatch = useDispatch<AppDispatch>()
  const [loading, setLoading] = useState(false)
  const navigate = useNavigate()

  const validationSchema = Yup.object({
    name: Yup.string().required('Name is required'),
    dealer_price_drive_link: Yup.string().required('Dealer price drive link is required'),
  })

  const formik = useFormik({
    initialValues: {
      name: '',
      dealer_price_drive_link: '',
      is_active: 1,
    },
    validationSchema,
    onSubmit: async (values) => {
      setLoading(true)
      try {
        let data
        if (id) {
          data = await dispatch(updateDealerPriceListApi({ id, payload: values }))
        } else {
          data = await dispatch(createDealerPriceListApi(values))
        }

        console.log('Form submission response:', data) // Debug log

        if (data.payload?.success) {
          setLoading(false)
          toast.success(data.payload.reason || 'Operation successful')
          navigate(-1)
        } else {
          setLoading(false)
          const errorMessage = data.payload?.reason || data.payload?.error || 'Something went wrong'
          toast.error(errorMessage)
        }
      } catch (error: any) {
        setLoading(false)
        console.error('Form submission error:', error) // Debug log
        const errorMessage = error?.response?.data?.reason || error?.message || 'An error occurred while submitting the form'
        toast.error(errorMessage)
      }
    },
  })

  useEffect(() => {
    if (id) {
      fetchDealerPriceListData()
    }
  }, [id])

  const fetchDealerPriceListData = async () => {
    try {
      const res = await dispatch(getDealerPriceListByIdApi(id))
      const dealerPriceListData = res.payload.data?.data || res.payload.data
      formik.setValues({
        name: dealerPriceListData.name || '',
        dealer_price_drive_link: dealerPriceListData.dealer_price_drive_link || '',
        is_active: dealerPriceListData.is_active || 1,
      })
    } catch (error) {
      toast.error('An error occurred while fetching dealer price list data')
    }
  }

  return (
    <div className='container mt-4'>
      <div className='card shadow' style={{ height: 'auto', minHeight: '500px' }}>
        <form onSubmit={formik.handleSubmit}>
          <div className='card-header bg-light d-flex justify-content-between align-items-center position-relative py-6'>
            <h2 className='mb-0'>{id ? 'Edit Dealer Price List' : 'Add Dealer Price List'}</h2>
            <button type='submit' className='btn btn-primary' disabled={loading}>
              {loading ? 'Saving...' : id ? 'Update' : 'Submit'}
            </button>
            <span
              className={`position-absolute border-primary`}
              style={{
                top: '12px',
                left: '0',
                height: '70%',
                width: '4px',
                backgroundColor: `var(--bs-primary)`,
              }}
            ></span>
          </div>

          <div className='card-body p-6'>
            <div>
              <div className='row g-3'>
                <div className='col-md-6'>
                  <label htmlFor='name' className='form-label'>
                    Name <span className='text-danger'>*</span>
                  </label>
                  <input
                    type='text'
                    id='name'
                    name='name'
                    className='form-control'
                    value={formik.values.name}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    placeholder='Enter dealer price list name'
                  />
                  {formik.touched.name && formik.errors.name && (
                    <div className='text-danger'>{formik.errors.name}</div>
                  )}
                </div>

                <div className='col-md-6'>
                  <label htmlFor='status' className='form-label me-3'>
                    Status
                  </label>
                  <select
                    id='status'
                    name='status'
                    className='form-select'
                    value={formik.values.is_active}
                    onChange={(e) => {
                      const value = e.target.value === '1' ? 1 : 0
                      formik.setFieldValue('is_active', value)
                    }}
                  >
                    <option value={1}>Active</option>
                    <option value={0}>Inactive</option>
                  </select>
                </div>

                <div className='col-md-12'>
                  <label htmlFor='dealer_price_drive_link' className='form-label'>
                    Dealer Price Drive Link <span className='text-danger'>*</span>
                  </label>
                  <input
                    type='text'
                    id='dealer_price_drive_link'
                    name='dealer_price_drive_link'
                    className='form-control'
                    value={formik.values.dealer_price_drive_link}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    placeholder='Enter dealer price drive link'
                  />
                  {formik.touched.dealer_price_drive_link && formik.errors.dealer_price_drive_link && (
                    <div className='text-danger'>{formik.errors.dealer_price_drive_link}</div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  )
}

export default DealerPriceListForm

